import React, { FC, useState } from 'react';
import TFAFirstStep from './TFAFirstStep';
import TFASecondStep from './TFASecondStep';
import TFAThirdStep from './TFAThirdStep';
import ModalHeader from './ModalHeader';

const stepTitles = {
  1: 'Verify phone number',
  2: 'Two factor authentication',
  3: 'Phone verification',
};

interface Props {
  onClose(): void;
  phoneNumber: string;
}

const TFAForm: FC<Props> = ({ onClose, phoneNumber }) => {
  const [step, setStep] = useState(1);

  const renderContent = (stepToRender: number) => {
    switch (stepToRender) {
      case 1: return <TFAFirstStep setStep={setStep} phoneNumber={phoneNumber} handleClose={onClose} />;
      case 2: return <TFASecondStep setStep={setStep} />;
      case 3: return <TFAThirdStep handleClose={onClose} />;
      default: return <TFAFirstStep setStep={setStep} phoneNumber={phoneNumber} handleClose={onClose} />;
    }
  };

  return (
    <>
      <ModalHeader title={stepTitles[step]} onClose={onClose} />
      {renderContent(step)}
    </>
  );
};

export default TFAForm;
